import { IDocumentosPdf } from '../entities/IDocumentosPdf'
import { ILoteSolicitadoRepository } from '../repositories/ILoteSolicitadoRepository'

export interface IGetDocumentoPdf {
  execute(params: string): Promise<IDocumentosPdf>
}

export default class IGetDocumentoPedagioPdfImpl implements IGetDocumentoPdf {
  constructor(
    private readonly loteSolicitadoRepository: ILoteSolicitadoRepository,
  ) {}

  public async execute(params: string): Promise<IDocumentosPdf> {
    return this.loteSolicitadoRepository.getDocumentoPedagioPdf(params)
  }
}
